import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { pathgen } from 'object-path-generator';
import { useResponsive } from '~/client-flow/contexts';
import { CreateAVendorAccount } from '~/components/NavigationAndStructure/TopBar/CreateAVendorAccount';
import { useStoreActions } from '~/contexts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import styles from './TryAnchorBanner.module.scss';
export const TryAnchorBannerDataTestIds = pathgen('TryAnchorBannerDataTestIds');
const TryAnchorBanner = (param)=>{
    let { showBanner, isFixed, contentShift } = param;
    const { CLIENT_ONBOARDING_NEW_FLOW } = useFeatureFlags();
    const { isDesktop } = useResponsive();
    const { logBI } = useStoreActions();
    const useRelativeBanner = CLIENT_ONBOARDING_NEW_FLOW;
    const effectiveIsFixed = useRelativeBanner ? false : isFixed;
    const banner = /*#__PURE__*/ _jsx(AnimatePresence, {
        children: showBanner && /*#__PURE__*/ _jsx(motion.div, {
            className: cn(styles.bannerWrapper, {
                [styles.desktop]: isDesktop,
                [styles.mobile]: !isDesktop,
                [styles.notFixed]: !effectiveIsFixed
            }),
            initial: effectiveIsFixed ? {
                y: 32,
                opacity: 0
            } : {
                opacity: 0
            },
            animate: effectiveIsFixed ? {
                y: 0,
                opacity: 1
            } : {
                opacity: 1
            },
            exit: effectiveIsFixed ? {
                y: 32,
                opacity: 0
            } : {
                opacity: 0
            },
            transition: effectiveIsFixed ? {
                y: {
                    type: 'spring',
                    duration: 0.5,
                    bounce: 0.25
                },
                opacity: {
                    duration: 0.05,
                    ease: 'linear'
                }
            } : {
                duration: 0.3,
                ease: 'easeOut'
            },
            children: /*#__PURE__*/ _jsx(CreateAVendorAccount, {
                variant: "banner",
                onClick: ()=>logBI(18105),
                testId: TryAnchorBannerDataTestIds.CreateVendorAccountBtn()
            })
        })
    });
    if (useRelativeBanner) {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.bannerSlot,
            style: {
                minHeight: contentShift ? 140 : 0
            },
            "aria-hidden": !showBanner,
            "data-testid": TryAnchorBannerDataTestIds.BannerSlot(),
            children: banner
        });
    }
    return banner;
};
export default TryAnchorBanner;
